// Shop sign and plaque textures.
import * as THREE from 'three';
import { canvasTex } from '../lib/factory.js';

export function plateTex(text, twoLines) {
  return textTex(256, twoLines ? 160 : 56, (c) => {
    const h = twoLines ? 160 : 56;
    c.fillStyle = '#f7f7f2';
    c.fillRect(0, 0, 256, h);
    c.strokeStyle = '#111';
    c.lineWidth = 4;
    c.strokeRect(2, 2, 252, h - 4);
    c.fillStyle = '#1d47a8';
    c.fillRect(4, 4, 30, h - 8);
    c.fillStyle = '#fff';
    c.font = 'bold 20px Arial';
    c.textAlign = 'center';
    c.fillText('E', 19, h - 14);
    c.fillStyle = '#111';
    c.font = `bold ${twoLines ? 64 : 40}px Arial`;
    if (twoLines) {
      const [a, b] = text.split(' ');
      c.fillText(a, 145, 70);
      c.fillText(b, 145, 140);
    } else c.fillText(text, 145, 42);
  });
}
export function textTex(w, h, draw) {
  const t = canvasTex(w, h, draw);
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
  return t;
}
